import { render, staticRenderFns } from "./PanelOrderGroup.vue?vue&type=template&id=96ccc5d6&scoped=true"
import script from "./PanelOrderGroup.vue?vue&type=script&lang=js"
export * from "./PanelOrderGroup.vue?vue&type=script&lang=js"
import style0 from "./PanelOrderGroup.vue?vue&type=style&index=0&id=96ccc5d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ccc5d6",
  null
  
)

export default component.exports